import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalQuillConfig } from '../../constants/quillConfig';
import { ICommunityFeed } from 'src/app/core/domain/community-feed';

@Component({
  selector: 'app-community-feed-list',
  templateUrl: './community-feed-list.component.html',
  styleUrls: ['./community-feed-list.component.scss']
})
export class CommunityFeedListComponent implements OnInit {
  @Input() feedList: ICommunityFeed[] = [];
  // SAN-1436 — post after which the "New since your last visit" divider sits.
  @Input() newBoundaryUuid: string = null;
  // SAN-1436 — the last visit the divider is dated with, and the unseen posts
  // (orange dot). Both empty when the notification centre is off.
  @Input() newSince: string = null;
  @Input() unseenUuids: string[] = [];
  quillModules = GlobalQuillConfig;
  @Output() handleLoadMore = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  onScroll() {
    console.log("scrolled!!");
  }

  onDelete(index) {
    this.feedList.splice(index, 1);
  }

  onScrollDown(ev: any) {
    console.log("scrolled down!!", ev);
    this.handleLoadMore.emit()
    // if (this.hadMoreStartups) {
      // this.handleLoadMore();
    // }
  }

  // get hadMoreStartups() {
    // return this.paginationMeta && (this.paginationMeta.currentPage * this.paginationMeta.itemsPerPage) < this.paginationMeta.totalItems
  // }
}
